export default __webpack_public_path__ + "static/media/logo-smart.d83dbe7f.png";